var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-card",
        { staticClass: "no-shadow" },
        [
          _c(
            "v-card-title",
            { staticClass: "ctn_search" },
            [
              _vm._v(" Roles "),
              _c("v-spacer"),
              _vm.isMaster
                ? _c("v-combobox", {
                    ref: "company",
                    staticClass: "input_filter",
                    attrs: {
                      items: _vm.itemsDataCompany,
                      "search-input": _vm.searchCompany,
                      "item-value": "_id",
                      "item-text": "name",
                      placeholder: "filtrar empresa",
                      clearable: "",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchCompany = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchCompany = $event
                      },
                    },
                    model: {
                      value: _vm.company,
                      callback: function ($$v) {
                        _vm.company = $$v
                      },
                      expression: "company",
                    },
                  })
                : _vm._e(),
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.getHeader,
              items: _vm.itemsData,
              loading: _vm.getLoadTable,
              "footer-props": {
                "items-per-page-options": [10],
              },
              "items-per-page": 10,
              "server-items-length": _vm.totalNumberOfItems,
              options: _vm.pagination,
              "loading-text": "Cargando información ….",
              search: _vm.search,
            },
            on: {
              "update:options": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.state`,
                  fn: function ({ item }) {
                    return [
                      item.state == true
                        ? _c(
                            "div",
                            [
                              _c("v-icon", { staticClass: "i-con on" }, [
                                _vm._v("mdi-checkbox-blank-circle"),
                              ]),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("v-icon", { staticClass: "i-con off" }, [
                                _vm._v("mdi-checkbox-blank-circle"),
                              ]),
                            ],
                            1
                          ),
                    ]
                  },
                },
                {
                  key: `item.activate`,
                  fn: function ({ item }) {
                    return [
                      item.activate == 1
                        ? _c("div", { staticClass: "lb lb_activo" }, [
                            _vm._v("Activo"),
                          ])
                        : _c("div", { staticClass: "lb lb_inactivo" }, [
                            _c("span", { staticClass: "span_inactive" }, [
                              _vm._v("Inactivo"),
                            ]),
                          ]),
                    ]
                  },
                },
                {
                  key: `item.company`,
                  fn: function ({ item }) {
                    return [_vm._v(" " + _vm._s(item.company.name) + " ")]
                  },
                },
                {
                  key: `item._modules`,
                  fn: function ({ item }) {
                    return _vm._l(item._modules, function (elem) {
                      return _c(
                        "div",
                        {
                          key: elem._id + Math.random(),
                          staticClass: "tab_colum",
                        },
                        [
                          elem.checkModule == true
                            ? _c("div", [
                                elem.nameModule == "Master"
                                  ? _c("span", { staticClass: "master_span" }, [
                                      _vm._v(
                                        " " + _vm._s(`${elem.nameModule}`) + " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        " " + _vm._s(`${elem.nameModule}`) + " "
                                      ),
                                    ]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    })
                  },
                },
                {
                  key: `item.description`,
                  fn: function ({ item }) {
                    return [_vm._v(" " + _vm._s(item.description) + " ")]
                  },
                },
                {
                  key: `item.createdAt`,
                  fn: function ({ item }) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm._f("formatDate")(item.createdAt)) + " "
                      ),
                    ]
                  },
                },
                {
                  key: `item.actions`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "table_menu",
                                            attrs: {
                                              color: "primary",
                                              icon: "",
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-menu-down")])],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "list_action" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { plain: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editItem(item)
                                        },
                                      },
                                    },
                                    [_c("span", [_vm._v("Editar")])]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "list_action" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { plain: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteItem(item)
                                        },
                                      },
                                    },
                                    [_c("span", [_vm._v("Eliminar")])]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("Edit", {
        attrs: { data: _vm.itemObjct, visible: _vm.EditFlag },
        on: {
          close: function ($event) {
            _vm.EditFlag = false
          },
        },
      }),
      _c("Delete", {
        attrs: { data: _vm.itemObjct, visible: _vm.DeleteFlag },
        on: {
          close: function ($event) {
            _vm.DeleteFlag = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }